export default "__VITE_ASSET__8de752d9__"